module.exports = __webpack_public_path__ + "img/drug_enforcement-stage_1.1.d5e096f7.jpg";